import React, { useState, useEffect, useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButtonWhatsApp } from './iconButton';

interface WhatsAppProps {
  phone: string;
  className?: string;
}

const WhatsApp: React.FC<WhatsAppProps> = ({ phone, className = '' }) => {
  const handleClick = () => {
    const url = `https://wa.me/${phone}`;
    window.open(url, '_blank');
  };

  const [expanded, setExpanded] = useState<string | false>(false);
  const [cpf, setCpf] = useState('');
  const [isCpfValid, setIsCpfValid] = useState(false);
  const accordionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (expanded && accordionRef.current) {
      accordionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [expanded]);

  const validateCPF = (cpf: string) => {
    const cpfPattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
    if (!cpfPattern.test(cpf)) {
      setIsCpfValid(false);
      return false;
    }
    setIsCpfValid(true);
    return true;
  };

  const handleValidate = () => {
    if (validateCPF(cpf)) {
      setIsCpfValid(true);
      setExpanded('panel1');
    } else {
      alert('CPF inválido!');
      setIsCpfValid(false);
      setExpanded(false);
    }
  };

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const WhatsAppLink = process.env.REACT_APP_WHATSAPP_LINK || '';

  return (
    <>
      <div className="w-full max-w-4xl mx-auto">
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionDetails>
            <Typography
              style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <a
                href={WhatsAppLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                }}
              >
                <div className="w-full mx-auto sm:max-w-4xl px-1 sm:px-0">
                  <img
                    src="/assets/logos/Bot-app.jpeg"
                    alt="logo"
                    className="w-full h-auto rounded-lg max-h-[1000px] sm:max-h-none object-contain"
                  />
                </div>
                <IconButtonWhatsApp phone={phone} message="" />
              </a>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <button onClick={handleClick} className={className} />
    </>
  );
};

export default WhatsApp;
